/**
 * Store marketing version helpers.
 *
 * Kept byte-for-byte equivalent to api-v2's
 * `MobileAppVersion/core/mobileAppVersion.utils.ts` and mobile-v2's
 * `src/utils/functions/compareVersions.ts`. The form's "min <= latest" rule must
 * agree with the server guard, otherwise the panel accepts a config the API then
 * rejects (or worse, the reverse).
 */

const MAX_SEGMENT = 9999
const MAX_SEGMENT_COUNT = 4

export function parseVersion(raw?: string | null): number[] | null {
  if (!raw) return null

  const core = raw.trim().split(/[-+]/)[0]
  if (!core) return null

  const parts = core.split(".")
  if (parts.length === 0 || parts.length > MAX_SEGMENT_COUNT) return null

  const nums = parts.map((part) => (/^\d+$/.test(part) ? Number(part) : NaN))
  if (nums.some((n) => Number.isNaN(n) || n > MAX_SEGMENT)) return null

  return nums
}

export function isValidVersion(raw?: string | null): boolean {
  return parseVersion(raw) !== null
}

/** -1 if a < b, 0 if equal, 1 if a > b. Missing segments count as 0. */
export function compareVersions(a: string, b: string): -1 | 0 | 1 {
  const partsA = parseVersion(a) ?? []
  const partsB = parseVersion(b) ?? []
  const len = Math.max(partsA.length, partsB.length)

  for (let i = 0; i < len; i += 1) {
    const numA = partsA[i] ?? 0
    const numB = partsB[i] ?? 0
    if (numA < numB) return -1
    if (numA > numB) return 1
  }
  return 0
}
